export default {
  methods: {
    diffTabPlugin() {
      this.$changeOptionsEV('diff_tab', "categoryMode", false, null, this.myid)
    }
  }
}